
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyPilarSquare as ObiBuoyPilarSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-pilar-square.js';
 
 
 

 
 export const ObiBuoyPilarSquare = createComponent({
   react: React,
   tagName: 'obi-buoy-pilar-square',
   elementClass: ObiBuoyPilarSquareElement,
   events: {
     
   }
  });
 
 